export default (store) => {
    return store.subscribe((mutation) => {
        switch (mutation.type) {
            case 'events/MERGE_STATE':
                store.dispatch('notifications/onCheck', mutation.payload);
                break;

            case 'messages/MERGE_STATE':
                store.dispatch('notifications/onCheck', mutation.payload);
                break;
        }
    })
};
